import axiosApi from "axios";

const InstallAxios = (app) => {
  let HELPER_BASE = process.env.VUE_APP_HELPER_BASE;

  if (typeof VC_PUBLIC_CUSTOM_BASE_URL !== "undefined") {
    HELPER_BASE = VC_PUBLIC_CUSTOM_BASE_URL;
  }

  app.config.globalProperties.$http = axiosApi.create({
    baseURL: HELPER_BASE.endsWith("/app") ? HELPER_BASE : HELPER_BASE + "/app",
    headers: { "X-Requested-With": "XMLHttpRequest" },
  });
};

export default InstallAxios;
